// polyfill for Function.prototype.bind, required for wkhtmltopdf 0.12.4 with patched qt
require('./function-prototype-bind-polyfill');

require('lodash.custom');
window.$ = window.jQuery = require('jquery');
require('jquery-ui');
require('jquery-ui-touch-punch');
window.angular = require('angular');
require('angular-resource');
require('angular-cookies');
require('angular-sanitize');
require('angular-route');
require('angular-animate');
require('angular-dragdrop');
require('angular-translate-1.1.1');
window.LZString = require('lz-string');
window.SVG2JS = require('svg2js-data');

window.console.log = window.console.warn = function() {};
